export default __webpack_public_path__ + "static/media/grubby-2.52b7b9d1.jpg";